import MemberLectures from "@/features/dashboard/members/MemberLectures";

function MemberLecturesDB() {
  return <MemberLectures />;
}

export default MemberLecturesDB;
